import React from "react";

import PropTypes from "prop-types";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { Footer } from "../../components/Footer/Footer";

export function Investigation({ app, config }) {
  return (
    <div className="app investigation">
      <div className="appContent">
        <LayoutWrapper>
          <Grid className="container-investigation">
            <Card
              app={app}
              header={{
                hardTitle: "Apuração",
              }}
              exportContainer
              exportTable
              exportTableId="SPdgscP"
              style={{ margin: "0 0 16px" }}
            >
              <NativeObject
                app={app}
                key="SPdgscP"
                reference={{ id: "SPdgscP" }}
                style={{
                  width: "100%",
                  height: "calc(100vh - 240px)",
                }}
              />
            </Card>
          </Grid>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

Investigation.defaultProps = {
  app: null,
  config: {},
};

Investigation.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};
